"use strict";

/**
 * @type Controller
 * @name printRundownDialogCtrl
 * @packageName printRundown_dialog_ctrl.js
 *
 * @description PrintRundownDialog
 *
 *
 */
class printRundownDialogCtrl {

    constructor($scope, $mdDialog, $http, moment, broadcast, filters) {
        this.$mdDialog = $mdDialog;
        this.$http = $http;
        this.$moment = moment;
        this.data = null;

        $scope.close = () => {
            this.close();
        };

        let url = '/broadcasts/printdata/' + broadcast + '?filters=' + filters;
        this.$http.get(url).then((response) => {
            this.data = response.data;

            this.generatePage({
                title: this.data.title,
                time: moment(this.data.start).format('LLLL')
            });
        });

    }

    close() {
        this.$mdDialog.hide();
    }

    fillPage(doc) {

        doc.fontSize(22)
            .text(doc.info.title, {align: 'center'}, 20)
            .moveDown(0.25);

        doc.fontSize(16)
            .text(doc.info.time, {align: 'center'})
            .moveDown();

        for(let blocks in this.data.blocks){

            // Give the positions outside the item loop
            let topPos = 80;
            for(let items in this.data.blocks[blocks].items){

                let item = this.data.blocks[blocks].items[items];

                let startTime = moment(item.start)
                    .format('LTS');

                let duration = moment().startOf('day')
                    .seconds(item.duration)
                    .format('mm:ss');

                let itemType = item.model_type.name;
                let itemTitle = item.title;
                let itemDescription = item.details;
                let itemContactLength = item.contacts.length;

                let height = 70;
                let contactHeight = 0;

                // Add some height when there are contacts
                if(itemContactLength){
                    height = 90 + (50 * itemContactLength);
                }

                let itemTopPosition = topPos;

                // Line on the left side with color of the item type
                doc.rect(0, itemTopPosition, 6, height)
                    .fill(item.model_type.options.color);

                // This is the line at the start of the item
                doc.moveTo(0, itemTopPosition)
                    .lineTo(800, itemTopPosition)
                    .stroke();

                // Display starttime in 00:00:00
                doc.moveTo(0, itemTopPosition)
                    .fontSize(16)
                    .fill('#000')
                    .text(startTime, 20, (itemTopPosition + 8));

                // Display duraion in 00:00
                doc.moveTo(0, itemTopPosition)
                    .fontSize(14)
                    .text(duration, 47, (itemTopPosition + 28));

                // Display the itemtype text
                doc.moveTo(0, itemTopPosition)
                    .fontSize(14)
                    .text(itemType, 47, (itemTopPosition + 48));

                // Display the title of the item
                doc.moveTo(0, itemTopPosition)
                    .fontSize(20)
                    .text(itemTitle, 100, (itemTopPosition + 25));

                // If there are contacts, display them accordingly
                for(let id in item.contacts){
                    let contact = item.contacts[id];
                    let contactName = contact.firstname + " " + contact.lastname;
                    let contactEmail = contact.email;
                    let contactPhone = contact.phone;

                    // Only display contacts trans on the first contact entry
                    doc.moveTo(0, itemTopPosition)
                        .fontSize(16)
                        .text("Contacten", 100, (itemTopPosition + 68));

                    doc.moveTo(0, itemTopPosition)
                        .fontSize(14)
                        .text(contactName, 110, (itemTopPosition + 88) + (contactHeight * 50));

                    doc.moveDown(0.15);

                    doc.moveTo(0, itemTopPosition)
                        .fontSize(11)
                        .text(contactPhone, 110);

                    doc.moveDown(0.15);

                    doc.moveTo(0, itemTopPosition)
                        .fontSize(11)
                        .text(contactEmail, 110);

                    contactHeight++;
                }

                // This is the line at the end of the item
                doc.moveTo(0, itemTopPosition + height)
                    .lineTo(800, itemTopPosition + height)
                    .stroke();

                topPos = topPos+height;
            }
        }

    }

    // generatePage(info) {
    //
    //     let doc = new PDFDocument({
    //         info: info,
    //         layout: 'portrait',
    //         size: 'A4',
    //         margin: {
    //             top: 50,
    //             bottom: 50,
    //             left: 50,
    //             right: 50
    //         }
    //     });
    //
    //     this.fillPage(doc);
    //
    //     // pipe the document to a blob
    //     let stream = doc.pipe(blobStream());
    //
    //     doc.end();
    //
    //     stream.on('finish', () => {
    //
    //         // get a blob you can do whatever you like with
    //         let blob = stream.toBlob('application/pdf');
    //
    //         //or get a blob URL for display in the browser
    //         let url = stream.toBlobURL('application/pdf');
    //         document.querySelector('#pdfkit').src = url;
    //
    //         setTimeout(function() {
    //             // document.querySelector('#pdfkit').contentWindow.print();
    //         }, 100);
    //     });
    // }
}


/*
 * Inject dependicies
 */
printRundownDialogCtrl.$inject = ['$scope', '$mdDialog', '$http', 'moment', 'broadcast', 'filters', '$timeout'];


/*
 * Browsify connection: execute controller
 */
module.exports = printRundownDialogCtrl;
